const logos = ["Northwind HR", "Acme People", "Loop & Co.", "Kindred", "Pulse Labs", "Helix Group", "Atlas Studio"];

export const LogoStrip = () => (
  <section className="container mx-auto px-4 lg:px-8 py-12 lg:py-16">
    <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-6">
      Trusted by people teams across the US
    </p>
    <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4 opacity-70">
      {logos.map((l) => (
        <span
          key={l}
          className="text-lg sm:text-xl font-bold tracking-tight text-foreground/70"
          style={{ fontFamily: "Satoshi, sans-serif" }}
        >
          {l}
        </span>
      ))}
    </div>
  </section>
);
